export var Display;
(function (Display) {
    Display["mobile"] = "mobile";
    Display["desktop"] = "desktop";
})(Display || (Display = {}));
export var Variant;
(function (Variant) {
    Variant["lg"] = "lg";
    Variant["md"] = "md";
    Variant["sm"] = "sm";
})(Variant || (Variant = {}));
export var DotSize;
(function (DotSize) {
    DotSize[DotSize["lg"] = 1] = "lg";
    DotSize[DotSize["md"] = 0.75] = "md";
    DotSize[DotSize["sm"] = 0.5] = "sm";
})(DotSize || (DotSize = {}));
//# sourceMappingURL=Carousel.types.js.map